import loadable from '@loadable/component';

export const LazyCurationDetails = loadable(
  () =>
    import(
      /* webpackChunkName: "content/catalog/curationdetails" */
      '.'
    ),
);
